/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field[_ngcontent-%COMP%]{display:block}textarea[_ngcontent-%COMP%]{height:100px;resize:vertical}\n/*# sourceMappingURL=edit-file-dialog.component.css.map*/"];
export { styles as styles };
